const CHAT = {
  //  UserListHeader
  ONLINE: "آنلاین",
  SETTINGS: "تنظیمات",
  OFFLINE: "آفلاین",
  CHANGE_STATUS: "تغییر وضعیت",
  SORT: "مرتب کردن",
  HOME: "صفحه اصلی",
  AGENTS: "همکاران",
  ONLINE_USERS: "کاربران آنلاین",
  UNLIMITED: "نامحدود",
  REMAINING_CONVS: "مکالمات باقی مانده",
  REMAINING: "باقی مانده",
  SEARCH_IN_CONVS: "جست و جو در بین مکالمات",

  // UserListFilter
  PENDING: "در انتظار پاسخ",
  ONGOING: "در حال مکالمه",
  OTHERCONVS: "مکالمه‌های دیگر",
  NEWEST: "جدید ترین",
  OLDEST: "قدیمی ترین",

  // UserList
  DELETE_ALL: "پاک کردن همه ؟",
  CLOSE_ALL: "بستن همه مکالمات ؟",
  UPDATING: "درحال بروز رسانی ...",
  THERE_IS_NO_CONV: "مکالمه ای وجود ندارد",
  SHOW_MORE: "بیشتر",

  // ConversationsHeader
  TRANSFER_CONV: "انتقال مکالمه",
  AGENT_NOT_FOUND: "اپراتوری پیدا نشد.",
  BLACK_LIST: "انتقال به لیست سیاه",
  CLOSE_CONV: "بستن مکالمه",
  REJECT_CONV: "رد مکالمه",
  ACCEPT_CONV: "قبول مکالمه",
  UPDATE_CONV: "به روزرسانی مکالمه",
  CONV_UPDATED: "مکالمه به روز شد",
  TRANSFER_TO_ME: "انتقال به خود",
  ROADMAP: "نقشه راه",

  ROADMAP_MODAL: {
    TITLE: "نقشه راه مشتری",
    ENTER: "ورود",
    TOTAL_TIME: "کل زمان کاربر در وبسایت",
    LAST_PAGE: "اخرین صفحه بازدید کاربر",
    TIME_SPENT: "#time# حضور در صفحه",
    AND: " و ",
  },

  // ConversationsBody
  //
  //

  // ConversationsFooter
  SEARCH_IN_MESSAGES: "جست و جو در پیام های آماده",
  ADD_MESSAGE: "+ افزودن",
  ADD_MESSAGE_TITLE: "افزودن پیام آماده",
  MSG_TITLE_PH: "عنوان پیام",
  MSG_CONTENT_PH: "محتوای پیام",
  PUBLIC: "عمومی",
  VISIBLE_FOR_ALL: "(قابل مشاهده برای تمامی هم تیمی ها)",
  EDIT_NOT_PERMIT: "تنها ایجاد کننده پیام میتواند آنرا تغییر دهد",
  // short messages
  // chat box
  CHAT_INPUT_PH: "از / برای دسترسی سریعتر به پیام‌های آماده استفاده کنید.",
  CHAT_INPUT_SHORT_PH: "اینجا بنویسید",
  // emojies
  // send
  SEND: "ارسال",

  USER_FORM_INFO: "اطلاعات فرم کاربر",

  // UserInfoBox
  LOGIN_TO_DASHBOARD: "ورود به داشبورد",
  LOGOUT: "خروج از اکانت",

  EMAIL: "ایمیل",
  PHONE: "موبایل",
  ID: "شناسه",

  COPY: "کپی",
  EIDT: "ویرایش",
  CANCEL: "انصراف",
  CONFIRM: "تایید",
  SAVE: "ذخیره",

  DESCRIPTION: "توضیحات",
  NOTES: "یاداشت",
  DESCRIPTION_PH: "بنویسید و اینتر بزنید",
  OPERATOR_NAME: "نام اپراتور",
  DEPARTMENT: "دپارتمان",
  USER_INFOS: "مشخصه‌‌های کاربر",
  LAST_SEEN: "آخرین بازدید",
  LOCKED: "قفل",
  USER_LAST_PAGE: "آخرین صفحه",
  SESSIONS: "جلسه‌ها",
  TIME_SPENT_IN_WEBSITE: "حضور در سایت",
  IP: "آی پی",
  DEVICE: "سیستم‌عامل",
  BROWSER: "مرورگر",
  PAGE: "در صفحه",
  REFERRAL: "ارجاع",

  // Common users
  // SEARCH : "Search",
  SEARCH: "جست و جو",
  YOU: "انتقال چت",

  THIS_LINK: "این لینک",
  UPGRADE_YOUR_PACKAGE:
    "برای قبول این مکالمه پکیج خود را از طریق #link# تمدید نمایید",
  CHARGE_YOUR_CONVS:
    " برای قبول این مکالمه ابتدا مکالمات خود را از طریق #link# شارژ نمایید",
  SELECT_CONV_TO_START_CHAT: "برای آغاز مکالمه کلیک کنید",
  TRANSFER_CONV_TO_ME: "برای انتقال مکالمه به خود کلیک کنید",

  TRANSFERED_CONV_TEXT: "یک مکالمه از سمت #name# به شما انتقال داده شده",
  ACCEPT: "قبول",
  REJECT: "رد",

  REPLAY: "پاسخ",
  EDITED: "ادیت شده",
  EDITING: "ویرایش پیام",

  COPY_TEXT: "کپی متن",
  EDIT: "ویرایش پیام",
  MESSAGE_HAS_BEEN_EDITED: "این پیام قبلا یکبار ویرایش شده است !",
  EDIT_ONLY_LAST_12_HOURS_MESSAGES:
    "فقط پیام های 12 ساعت اخیر را میتوانید ویرایش کنید !",
  USER_TAG: "کاربر",

  DROP_FILE_HERE: "فایل را اینجا رها کنید",

  USER_INFO: "جزئیات",

  SURE_WANT_TO_TRANSFER_TO_YOURSELF:
    "آیا از انتقال این مکالمه به خود اطمینان دارید؟",

  CONFIRM_BLOCK_TEXT: "آیا میخواهید این کاربر را از لیست سیاه خارج کنید؟  ",
};

export default CHAT;
